import type { KeyCombo } from '../types';
export type ParsedKeyCombo = {
  key: string;
  meta: boolean;
  ctrl: boolean;
  shift: boolean;
  alt: boolean;
};

/** matchesKeyCombo が KeyboardEvent から読むフィールドだけを切り出した形（テスト容易性のため） */
export type KeyComboEventLike = {
  key: string;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
};
const MODIFIER_TOKENS = new Set(['meta', 'ctrl', 'shift', 'alt']);
export function parseKeyCombo(combo: KeyCombo): ParsedKeyCombo {
  const tokens = combo.toLowerCase().split('+');
  const parsed: ParsedKeyCombo = {
    key: '',
    meta: false,
    ctrl: false,
    shift: false,
    alt: false
  };
  for (const token of tokens) {
    if (token === 'meta') parsed.meta = true;else if (token === 'ctrl') parsed.ctrl = true;else if (token === 'shift') parsed.shift = true;else if (token === 'alt') parsed.alt = true;else parsed.key = token;
  }
  return parsed;
}

/**
 * modifier の並び順差（例: mac の `meta+shift+o` と `shift+meta+o`）で別物扱いされないよう、
 * 正規形（ctrl+alt+shift+meta+key）へ揃える。表示順は keyComboParts / formatKeyLabel と一致。
 * registry の衝突・禁止検査（validateShortcutRegistry）の比較キーに使う。
 */
export function canonicalizeKeyCombo(combo: KeyCombo): KeyCombo {
  const parsed = parseKeyCombo(combo);
  const tokens: string[] = [];
  if (parsed.ctrl) tokens.push('ctrl');
  if (parsed.alt) tokens.push('alt');
  if (parsed.shift) tokens.push('shift');
  if (parsed.meta) tokens.push('meta');
  if (parsed.key) tokens.push(parsed.key);
  return tokens.join('+');
}
export function isValidKeyCombo(combo: KeyCombo): boolean {
  const tokens = combo.toLowerCase().split('+');
  const keyTokens = tokens.filter(token => !MODIFIER_TOKENS.has(token));
  return keyTokens.length === 1 && keyTokens[0] !== undefined && keyTokens[0].length > 0;
}

/**
 * modifier は完全一致で判定する。
 * 余分な alt/shift 付きを除外するのは既存 useToggleAiChatByKeyPress の防御
 * （Ctrl+Shift+J = DevTools 等のブラウザ既定を奪わない）の標準化。
 */
export function matchesKeyCombo(event: KeyComboEventLike, combo: KeyCombo): boolean {
  const parsed = parseKeyCombo(combo);
  // スペースキーの event.key は " "（半角スペース）。registry は "space" トークンで
  // 表現する（forbiddenKeyCombos の ctrl+space 等）ため、ここで正規化して突き合わせる
  const eventKey = event.key === ' ' ? 'space' : event.key.toLowerCase();
  return eventKey === parsed.key && event.metaKey === parsed.meta && event.ctrlKey === parsed.ctrl && event.shiftKey === parsed.shift && event.altKey === parsed.alt;
}